import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import cn from 'classnames';
import IconTrash from '@dealroadshow/uikit-icon/IconTrash';
import Tooltip from '@dealroadshow/uikit-tooltip';
import { dataTableStyles } from '@dealroadshow/uikit-table/DataTable';
import { useDialInCountriesTableContext } from '../DialInCountriesTableContext';
import { IDialInCountryTableRowItem } from '../interfaces';
import styles from '../dialInCountriesTable.module.scss';

interface IProps {
  row: IDialInCountryTableRowItem,
}

const DeleteCell = (
  {
    row,
  }: IProps,
) => {
  const {
    fields,
    disabled,
  } = useDialInCountriesTableContext();

  return !disabled && !!row.fieldIndex && (
    <Button
      className={ cn(dataTableStyles.actionItem, styles.deleteRowBtn) }
      dataTest="deleteDialInCountryButton"
      variant={ ButtonVariantType.text }
      onClick={ () => {
        if (fields.length > 1) {
          fields.remove(row.fieldIndex);
        }
      } }
    >
      <Tooltip content="Delete country">
        <IconTrash />
      </Tooltip>
    </Button>
  );
};

export default DeleteCell;
